/*
 * Delivery dates for the sofa overview page and the USP tiles.
 *
 * 10-10-2026: SINGLE SOURCE OF TRUTH is now our own picker, assets/sr-leverdatum.js
 * (window.SRLevering), which reads the shop metafield swissrelax.levering maintained in the
 * leverkalender. Same rules as the product-page picker, so the pages can never disagree.
 * Buunto is only used as a fallback while it is still installed.
 *
 * If no rules are available, nextDates() returns null and the caller hides the
 * calendar rather than showing an invented date.
 */
window.SwissRelaxDelivery = (function () {
  'use strict';

  var DAY_INDEX = {
    SUNDAY: 0, MONDAY: 1, TUESDAY: 2, WEDNESDAY: 3,
    THURSDAY: 4, FRIDAY: 5, SATURDAY: 6
  };
  var DAY_NAME = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];

  function own() {
    var api = window.SRLevering;
    return api && api.config() ? api : null;
  }

  function buunto() {
    try {
      var s = window.Buunto && window.Buunto.datePicker && window.Buunto.datePicker.settings;
      if (!s || !s.availableWeekDays || !s.availableWeekDays.length) { return null; }
      return s;
    } catch (e) { return null; }
  }

  // Buunto-shaped settings, kept for any caller that still reads them.
  function settings() {
    var api = own();
    if (api) {
      var c = api.config();
      return {
        availableWeekDays: (c.weekdays || []).map(function (n) { return DAY_NAME[n]; }),
        disabledDates: c.closed || [],
        firstAvailableDateInDays: c.firstDays,
        lastAvailableDateInDays: c.lastDays,
        timezoneId: 'Europe/Brussels'
      };
    }
    return buunto();
  }

  function shopToday(tz) {
    var now = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: tz || 'Europe/Brussels',
        year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(now);
      var bits = parts.split('-');
      return new Date(+bits[0], +bits[1] - 1, +bits[2]);
    } catch (e) {
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }
  }

  function iso(d) {
    var m = String(d.getMonth() + 1);
    if (m.length < 2) { m = '0' + m; }
    var day = String(d.getDate());
    if (day.length < 2) { day = '0' + day; }
    return d.getFullYear() + '-' + m + '-' + day;
  }

  function nextDates(count) {
    var api = own();
    if (api) { return api.nextDates(count || 5); }

    var s = buunto();
    if (!s) { return null; }
    var allowed = (s.availableWeekDays || [])
      .map(function (d) { return DAY_INDEX[d]; })
      .filter(function (n) { return typeof n === 'number'; });
    if (!allowed.length) { return null; }
    var blocked = s.disabledDates || [];
    var offset = typeof s.firstAvailableDateInDays === 'number' ? s.firstAvailableDateInDays : 1;
    var last = typeof s.lastAvailableDateInDays === 'number' ? s.lastAvailableDateInDays : 90;
    var want = count || 5;
    var cursor = shopToday(s.timezoneId);
    cursor.setDate(cursor.getDate() + offset);
    var out = [];
    for (var i = 0; i <= last && out.length < want; i++) {
      if (allowed.indexOf(cursor.getDay()) !== -1 && blocked.indexOf(iso(cursor)) === -1) { out.push(new Date(cursor.getTime())); }
      cursor.setDate(cursor.getDate() + 1);
    }
    return out.length ? out : null;
  }

  function deliversOnSaturday() {
    var s = settings();
    return !!(s && (s.availableWeekDays || []).indexOf('SATURDAY') !== -1);
  }

  return {
    settings: settings,
    nextDates: nextDates,
    deliversOnSaturday: deliversOnSaturday
  };
})();
